import React from 'react';
import { DetailContainer, DetailTitle, DetailTable, DetailRow, DetailLabel, DetailValue } from './styles';

/** 동의 6: 개인정보 제3자 제공 동의 — 늘픔가치 (케어링노트 경로 전용, CONSENT_VERSION 20260902) */
const ConsentDetail6: React.FC = () => (
  <DetailContainer>
    <DetailTitle>개인정보 제3자 제공 동의 (늘픔가치)</DetailTitle>
    <DetailTable>
      <tbody>
        <DetailRow>
          <DetailLabel>제공받는 자</DetailLabel>
          <DetailValue><strong>사단법인 늘픔가치</strong> (케어링노트 운영 기관)</DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>제공받는 목적</DetailLabel>
          <DetailValue>
            <ul>
              <li>찾아가는 복약상담 기록의 <strong>관리</strong></li>
              <li>상담 약사의 <strong>복약상담 수행</strong></li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>제공하는 항목</DetailLabel>
          <DetailValue>
            <ul>
              <li>복용 중 의약품 목록</li>
              <li>약물 분석 보고서 열람 정보</li>
              <li>PhAI 환자번호</li>
            </ul>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>보유·이용 기간</DetailLabel>
          <DetailValue>
            <strong>찾아가는 복약상담소 사업 제공 기간 및 사업 종료 후 3년</strong>
          </DetailValue>
        </DetailRow>
        <DetailRow>
          <DetailLabel>동의 거부 권리 및 불이익</DetailLabel>
          <DetailValue>
            귀하는 본 개인정보의 제3자 제공에 동의를 거부할 권리가 있습니다.
            <p className="note">
              ※ 단, 본 동의 없이는 케어링노트를 통한 복약상담 연동 서비스를 제공할 수 없습니다.
            </p>
          </DetailValue>
        </DetailRow>
      </tbody>
    </DetailTable>
  </DetailContainer>
);

export default ConsentDetail6;
